// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ServiceResult } from "@insite/client-framework/Services/ApiService";
import {
    requestSystemList as requestSystemListApi,
    RequestSystemListApiParameter,
    RequestSystemListModel,
} from "@stoneage/App/Services/SystemList/SystemListService";

export interface RequestSystemListParameter {
    slug: string;
    values?: Array<any>;
}

type HandlerType = ApiHandlerDiscreteParameter<
    RequestSystemListParameter & HasOnSuccess<RequestSystemListModel> & HasOnError<string>,
    RequestSystemListApiParameter,
    ServiceResult<RequestSystemListModel>
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        url: {
            ...props.parameter,
        } as RequestSystemListModel,
    };
};

export const RequestSystemList: HandlerType = async props => {
    props.apiResult = await requestSystemListApi(props.apiParameter);
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (!props.apiResult.successful) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.apiResult.errorMessage!);
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (props.apiResult.successful) {
        // markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.(props.apiResult.result);
    }
};

export const chain = [PopulateApiParameter, RequestSystemList, ExecuteOnErrorCallback, ExecuteOnSuccessCallback];

const requestSystemList = createHandlerChainRunner(chain, "RequestSystemList");
export default requestSystemList;
